import React from 'react';
import { motion } from 'framer-motion';

interface PageHeroProps {
  title: string;
  subtitle?: string;
  tag?: string;
}

/**
 * 统一的页面首屏 Hero 组件
 * 使用暗色沙丘背景图，配合渐变叠加层和入场动画
 */
export function PageHero({ title, subtitle, tag }: PageHeroProps) {
  return (
    <section className="relative h-[60vh] min-h-[500px] flex items-center justify-center overflow-hidden">
      {/* 背景图层 */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url("/Homepage_2-05-scaled1.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      
      {/* 渐变叠加层 - 增强文字可读性 */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/70 z-[1]" />
      
      {/* 内容区域 */}
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        {/* 标签 */}
        {tag && (
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-block px-4 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm text-sm font-medium mb-6 tracking-wide"
          >
            {tag}
          </motion.span>
        )}
        
        {/* 标题 */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: tag ? 0.1 : 0 }}
          className="text-5xl md:text-7xl font-bold mb-6 tracking-tight"
        >
          {title}
        </motion.h1>
        
        {/* 副标题 */}
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: tag ? 0.2 : 0.1 }}
            className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto font-light leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}


